





















































import { defineComponent, ref } from '@vue/composition-api'
import Heading from '../components/Heading.vue'
import isEmpty from 'validator/es/lib/isEmpty'
import isEmail from 'validator/es/lib/isEmail'
import { useTournament } from '../reactive/tournament.state'
import { API } from '../api'

export default defineComponent({
  components: {
    Heading,
  },
  setup(props, { root }) {
    const { setTournament } = useTournament()

    const hasFailed = ref(false)
    const isPending = ref(false)
    const validModel = ref(false)
    const nameModel = ref<string>('')
    const ownerModel = ref<string>('')
    const emailModel = ref<string>('')

    async function submit() {
      hasFailed.value = false
      const response = await API.Tournament.create({
        name: nameModel.value,
        owner: ownerModel.value,
        email: emailModel.value,
      })
      if (response.isSuccessful && response.data) {
        setTournament(response.data)
        await root.$router.push({
          name: 'tournament.teams',
          params: { hash: response.data.adminId },
        })
      } else {
        hasFailed.value = true
      }
    }

    return {
      isPending,
      hasFailed,
      validModel,
      nameModel,
      ownerModel,
      emailModel,
      submit,
      rules: {
        isRequired: (value: string) =>
          !isEmpty(value) || root.$i18n.t('common.form.required'),
        isEmail: (value: string) =>
          isEmail(value) || root.$i18n.t('common.form.email'),
      },
    }
  },
})
